'use client';

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* 화살표는 Swiper 가 요구하는 마크업(div.swiper-button-prev)이라 그대로 둔다.
   키보드 이동은 Swiper 의 keyboard 모듈이 담당한다 */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { memo, useCallback, useState } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import {
  IconArrowRight15,
  IconArrowRight02,
  IconPlay03,
  IconPlay04,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  className?: string;
  type?: 'black' | 'white' | 'bottom01' | 'outside01' | undefined;
  size?: 'xsmall' | 'small' | 'medium' | undefined;
  bgType?: 'white' | 'black' | any;
  offsetTop?: number;
  onClickAutoplayControlBtn?: (value: boolean) => void;
  /**
   * 이전/다음 이동을 직접 처리할 때 쓴다. (이동 폭이 일정하지 않은 경우)
   * 넘기면 Swiper 기본 이동 대신 이 핸들러가 호출되므로,
   * ItemsSwiper 에 navigation 설정은 넘기지 말 것. (두 번 도는 걸 막는다)
   */
  onClickPrev?: () => void;
  onClickNext?: () => void;
}

const SwiperNavigation = ({
  className,
  type = 'black',
  size = 'small',
  bgType = 'white',
  offsetTop,
  onClickAutoplayControlBtn,
  onClickPrev,
  onClickNext,
}: IProps) => {
  const [isAutoPlay, setIsAutoPlay] = useState(true);

  // 자동재생 상태 전달
  const handleClickAutoplayControl = useCallback(() => {
    if (typeof onClickAutoplayControlBtn === 'function')
      onClickAutoplayControlBtn(isAutoPlay);

    setIsAutoPlay(!isAutoPlay);
  }, [isAutoPlay, onClickAutoplayControlBtn]);

  const param = {
    className: classNameBind([
      `swiper-navigation-${type || ''}`,
      className || '',
    ]),
    type,
    size,
    $bgType: bgType,
    $offsetTop: offsetTop,
  };

  return (
    <S.SwiperNavigation {...param}>
      {/* 화살표를 빠르게 클릭하면 브라우저가 인접 요소를 선택해서 onMouseDown={e => e.preventDefault()} 추가로 mousedown 기본동작 막음 */}
      <div
        className="swiper-button-prev"
        aria-label="이전 슬라이드 보기"
        onMouseDown={e => e.preventDefault()}
        onClick={onClickPrev}
      >
        {type === 'outside01' ? <IconArrowRight15 /> : <IconArrowRight02 />}
      </div>
      <div
        className="swiper-button-next"
        aria-label="다음 슬라이드 보기"
        onMouseDown={e => e.preventDefault()}
        onClick={onClickNext}
      >
        {type === 'outside01' ? <IconArrowRight15 /> : <IconArrowRight02 />}
      </div>
      {onClickAutoplayControlBtn && (
        <Button
          className={`swiper-button-autoplay-control ${
            isAutoPlay ? 'is-autoplay' : ''
          }`}
          label="자동재생 일시정지/재생"
          onClick={handleClickAutoplayControl}
        >
          {isAutoPlay ? (
            <span className="pause">
              <span className="line" />
              <span className="line" />
            </span>
          ) : (
            <span className="play">
              {type === 'bottom01' ? <IconPlay04 /> : <IconPlay03 />}
            </span>
          )}
        </Button>
      )}
    </S.SwiperNavigation>
  );
};

export default memo(SwiperNavigation);
